export default "__VITE_ASSET__BlzT0TOE__"